var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94531 7.24569L7.85311 2.33789L12.7609 7.24569",
    stroke: "#60D39C",
    strokeWidth: 2.61749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85156 14.1167V2.33789",
    stroke: "#60D39C",
    strokeWidth: 2.61749,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/up-icon.df604862c0e56583c89934ecdc7bdd94.svg";